import { combineReducers } from "redux";
import wallet from "./wallet";

export default combineReducers({ wallet });